import { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faSyncAlt } from '@fortawesome/free-solid-svg-icons';
import DateRange from "../../dateRange/DateRange";
import DropdownLiveSearch from "../../dropdownLiveSearch/DropdownLiveSearch";
import CustomTextField from "../../textField/CustomTextField";
import { getGlobalAuditFilters } from "../../../services/AuditLogs";
import { getAssetsForBrowser } from "../../../services/AssetBrowserAPI";
import { formatToUtcIso } from "../../../utils/timeFormat";
import { DEFAULT_DAYS_AUDITLOGS_DATA } from "../../../utils/constants";
import dayjs from "dayjs";
import "./AuditFilter.css";

const DEFAULT_RANGE_DAYS = DEFAULT_DAYS_AUDITLOGS_DATA; const DEFAULT_LIMIT = 50
const AuditFilter = ({ onSearch, onReset }) => {
  const { t } = useTranslation();

  const [username, setusername] = useState(null);
  const [auditCategory, setauditCategory] = useState(null);
  const [contextType, setcontextType] = useState(null);
  const [deviceName, setdeviceName] = useState(null);

  const [auditcategorydata, setAuditcategorydata] = useState([]);
  const [contextTypedata, setcontextTypedata] = useState([]);
  const [userNamedata, setuserNamedata] = useState([]);
  const [deviceNamedata, setdeviceNamedata] = useState([])

  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [rangeError, setRangeError] = useState('');


  const buildSearchData = (s = startDate, e = endDate) => {
    const now = dayjs();
    let start = dayjs(s);
    let end = dayjs(e);

    if (end.isAfter(now)) end = now;

    const raw = {
      start_date: formatToUtcIso(start),
      end_date: formatToUtcIso(end),
      context_type: contextType,
      audit_category: auditCategory,
      device_name: deviceName,
      user_name: username,
    };

    const searchData = {};
    Object.keys(raw).forEach((k) => {
      if (raw[k]) searchData[k] = raw[k];
    });
    return searchData;
  };

  const handleSearch = () => {
    if (rangeError) return; // guard
    const searchData = buildSearchData();
    onSearch?.(searchData);
  };

  const handleReset = () => {
    if (username) setusername(null);
    if (auditCategory) setauditCategory(null);
    if (deviceName) setdeviceName(null);
    if (contextType) setcontextType(null);

    // reset dates back to default window
    const now = dayjs();
    const start = now.subtract(DEFAULT_RANGE_DAYS, "day");
    setStartDate(start);
    setEndDate(now);
    setRangeError('');

    const defaults = buildSearchData(start, now);
    onReset?.(defaults);
  };
  const mapApiResponseToFilters = (dataArray) => {
    return dataArray.map((item) => (item.device_name));
  };
  const loadData = async () => {
    try {
      const rawFilters = await getGlobalAuditFilters();
      const assets = await getAssetsForBrowser();
      const deviceNameFilters = mapApiResponseToFilters(assets);
      const auditCategoryFilters = rawFilters?.audit_category ? (Array.isArray(rawFilters.audit_category) ? rawFilters.audit_category : [rawFilters.audit_category]) : [];
      const contextTypeFilters = rawFilters?.context_type ? (Array.isArray(rawFilters.context_type) ? rawFilters.context_type : [rawFilters.context_type]) : [];
      const userNameFilters = rawFilters?.user_name ? (Array.isArray(rawFilters.user_name) ? rawFilters.user_name : [rawFilters.user_name]) : [];
      const rawDeviceNames = rawFilters?.device_name ? (Array.isArray(rawFilters.device_name) ? rawFilters.device_name : [rawFilters.device_name]) : [];

      const mergedDeviceNames = Array.from(
        new Set([ ...rawDeviceNames, ...deviceNameFilters])
      );
      setAuditcategorydata(auditCategoryFilters);
      setcontextTypedata(contextTypeFilters);
      setuserNamedata(userNameFilters);
      setdeviceNamedata(mergedDeviceNames)
    } catch (err) {
      console.error('Global audit logs fetch failed:', err);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <div className="asset-filter-container">
      <div className="asset-filter-wrapper">
        <div className="filter-input-row">
          <DropdownLiveSearch options={userNamedata} label="User Name" value={username} onValueChange={(v) => setusername(v)} />
          <DropdownLiveSearch options={auditcategorydata} label="Audit Category" value={auditCategory} onValueChange={(v) => setauditCategory(v)} />
          <DropdownLiveSearch options={contextTypedata} label="Context Type" value={contextType} onValueChange={(v) => setcontextType(v)} />
          <DropdownLiveSearch options={deviceNamedata} label="Device name" value={deviceName} onValueChange={(v) => setdeviceName(v)} />
        </div>

        <div className="filter-button-row">
          <div className="date-range">
            <DateRange
              defaultDays={DEFAULT_RANGE_DAYS}
              startTime={startDate}
              endTime={endDate}
              onChange={({ startDate: s, endDate: e, rangeError: err }) => {
                setStartDate(s);
                setEndDate(e);
                setRangeError(err);
              }}
            />
          </div>

          <div className="action-buttons">
            <button
              className="btn btn-primary"
              onClick={handleSearch}
              disabled={!!rangeError}
              title={rangeError || undefined}
            >
              <FontAwesomeIcon icon={faSearch} className="me-1" />
              {t("Search") || "Search"}
            </button>
            <button className="btn btn-primary" onClick={handleReset}>
              <FontAwesomeIcon icon={faSyncAlt} className="me-1" />
              {t("Reset") || "Reset"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuditFilter;
